import {
  columnGroups,
  columnTitles,
  columnCodes,
} from 'constants/report99Data';
import * as XLSX from 'xlsx';

export const exportToExcel = (dataReports: any) => {
  const RESERVED_COLUMNS = 3;

  const row1 = ['', 'Columns', ''];

  const row2 = ['', '', ''];
  columnGroups.forEach((g) => {
    row2.push(g.name);
    for (let i = 1; i < g.size; i++) row2.push('');
  });

  const row3 = ['', '', '', ...columnTitles];
  const row4 = ['', '', '', ...columnCodes.map((c) => `="${c}"`)];

  const groupStartCol: Record<string, number> = {};
  let colIndexCounter = RESERVED_COLUMNS;

  columnGroups.forEach((group) => {
    groupStartCol[group.key] = colIndexCounter;
    colIndexCounter += group.size;
  });

  const optionDefsRow = new Array(RESERVED_COLUMNS + columnTitles.length).fill(
    '',
  );

  columnGroups.forEach((group) => {
    const items = dataReports[group.key] || [];
    const startCol = groupStartCol[group.key];

    const firstEntity = items.find(
      (i: { entity_name: any }) => i.entity_name,
    )?.entity_name;
    if (!firstEntity) return;

    const firstEntityItems = items
      .filter((i: { entity_name: any }) => i.entity_name === firstEntity)
      .sort(
        (a: { data_point: string }, b: { data_point: string }) =>
          Number(a.data_point.replace('data_point_', '')) -
          Number(b.data_point.replace('data_point_', '')),
      );
    firstEntityItems.forEach(
      (item: { data_point: string; int_options_def: any }, idx: number) => {
        const colIndex = startCol + idx;

        if (item.int_options_def) {
          optionDefsRow[colIndex] = item.int_options_def;
        }
      },
    );
  });

  const row5 = [
    'Rows',
    'Description/Internal definition of the option',
    '="0040"',
    ...optionDefsRow.slice(RESERVED_COLUMNS),
  ];

  const codeMappingRows = [
    {
      label: 'KTQ:CO Type of contractual arrangement',
      values: [
        'Standalone arrangement',
        ' Overarching arrangement',
        'Subsequent or associated arrangement',
      ],
      cols: [0, 1, 2],
      baseCol: 3,
      count: 3,
    },
    {
      label: 'DSS:ZZ Data sensitivity',
      values: ['Low', 'Medium', 'High'],
      cols: [0, 1, 2],
      baseCol: 6,
      count: 3,
    },
    {
      label: 'SAA:ZZ Substitutability assessment',
      values: [
        'Not substitutable',
        'Highly complex substitutability',
        'Medium complexity in terms of substitutability',
        'Easily substitutable',
      ],
      cols: [0, 1, 2, 3],
      baseCol: 12,
      count: 4,
    },
    {
      label: 'KTW:ZZ Possibility of reintegration of the contracted service',
      values: ['Easy', 'Difficult', 'Highly complex'],
      cols: [0, 1, 2],
      baseCol: 16,
      count: 3,
    },
    {
      label: 'ISD:ZZ Impact of service discontinuing',
      values: ['Low', 'Medium', 'High'],
      cols: [0, 1, 2],
      baseCol: 19,
      count: 3,
    },
    {
      label: 'IFD:ZZ Impact of function discontinuing',
      values: ['Low', 'Medium', 'High'],
      cols: [0, 1, 2],
      baseCol: 9,
      count: 3,
    },
  ].map((codeMap) => {
    const row = new Array(RESERVED_COLUMNS + columnTitles.length).fill('');
    row[0] = codeMap.label;

    codeMap.values.forEach((val, idx) => {
      const colIndex = codeMap.baseCol + idx;
      if (colIndex < row.length) {
        row[colIndex] = val;
      }
    });

    return row;
  });

  const sheetData = [row1, row2, row3, row4, row5, ...codeMappingRows];

  const ws = XLSX.utils.aoa_to_sheet(sheetData);

  return ws;
};
